// src/lib/livret-sanitize-client.js — Phase A.7.1b (ADR-120) F-CRIT-1
//
// Defense-in-depth client : sanitize HTML voyageur AVANT injection
// dangerouslySetInnerHTML (PublicLivretPage). 2e couche de protection en
// complément de lib/livret-sanitize.js serveur (déjà sanitize avant INSERT DB).
//
// ⚠️ Import DIRECT (pas lazy) côté PublicLivretPage : empêche race condition
// où l'utilisateur verrait HTML brut quelques ms avant que le chunk arrive.
// DOMPurify standalone client ~ 7 kB gzip → acceptable bundle main voyageur.
//
// DUPLICATION CONTRÔLÉE : ALLOWED_TAGS / ALLOWED_ATTR / ALLOWED_URI_REGEXP
// DOIVENT rester strictement synchros avec lib/livret-sanitize.js (serveur CJS).
// Si tu modifies l'un, modifie l'autre dans le même commit.

import DOMPurify from "dompurify";

// Sync explicite avec lib/livret-sanitize.js (F-CRIT-1 + F-MOY-4)
export const ALLOWED_TAGS = [
  "p",
  "b",
  "i",
  "em",
  "strong",
  "ul",
  "ol",
  "li",
  "h2",
  "h3",
  "a",
  "br",
  "code",
  "div",
  "span",
];

export const ALLOWED_ATTR = ["href", "target", "rel"];

export const ALLOWED_URI_REGEXP = /^(https?|mailto|tel):/i;

const DOMPURIFY_CONFIG = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOWED_URI_REGEXP,
  KEEP_CONTENT: true, // F-CRIT-1 + F-MOY-4 : preserve text si wrapper rejeté
  ALLOW_DATA_ATTR: false,
};

/**
 * Sanitize HTML content côté client (defense-in-depth XSS).
 * Wrapper standalone, sans jsdom (browser-only).
 *
 * @param {unknown} html — HTML brut from livret_token_resolve.modules[*].content[lang]
 * @returns {string} — HTML sanitized, safe pour dangerouslySetInnerHTML
 *
 * Edge cases identiques côté serveur :
 *   - null / undefined / non-string → retourne ''
 *   - <script>...</script> totalement supprimé
 *   - href javascript: stripped (ALLOWED_URI_REGEXP)
 *   - data: URIs strippées
 */
export function sanitizeLivretHtml(html) {
  if (typeof html !== "string" || html.length === 0) return "";
  return DOMPurify.sanitize(html, DOMPURIFY_CONFIG);
}

/**
 * Helper validation couleur livret (F-MOY-1).
 *
 * @param {unknown} color — theme_color_primary venant du backend
 * @param {string[]} allowedColors — palette autorisée (ALLOWED_THEME_COLORS)
 * @param {string} fallback — couleur si invalid (typiquement DS.skyDeep)
 * @returns {string} — couleur valide (de la palette) ou fallback
 */
export function validateThemeColor(color, allowedColors, fallback) {
  if (typeof color !== "string") return fallback;
  if (!Array.isArray(allowedColors) || allowedColors.length === 0)
    return fallback;
  return allowedColors.includes(color) ? color : fallback;
}
